import angular from 'angular';

import component from './broadcast-select.component';

const BroadcastSelect = angular
    .module('control-room.experience-promoter.components.experience-manage.components.broadcast-select', [])
    .component('crBroadcastSelect', component);

export default BroadcastSelect;
